import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'printerAssignment/';

const initialState = {
    assignments: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
};

// Get all printer assignments
export const getPrinterAssignments = createAsyncThunk(
    'printerAssignment/getAll',
    async (_, thunkAPI) => {
        try {
            const result = await axios.get(API_URL + 'getPrinterAssignments');
            return result.data.assignments;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Assign or update printer
export const assignPrinter = createAsyncThunk(
    'printerAssignment/assign',
    async (printerData, thunkAPI) => {
        try {
            const result = await axios.post(API_URL + 'assignPrinter', printerData);
            return result.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Update printer status
export const updatePrinterStatus = createAsyncThunk(
    'printerAssignment/updateStatus',
    async (statusData, thunkAPI) => {
        try {
            const result = await axios.put(API_URL + 'updatePrinterStatus', statusData);
            return result.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Delete printer assignment
export const deletePrinterAssignment = createAsyncThunk(
    'printerAssignment/delete',
    async (assignmentID, thunkAPI) => {
        try {
            const result = await axios.delete(API_URL + `deletePrinterAssignment/${assignmentID}`);
            return result.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Test printer connection
export const testPrinter = createAsyncThunk(
    'printerAssignment/test',
    async (printerData, thunkAPI) => {
        try {
            const result = await axios.post(API_URL + 'testPrinter', printerData);
            return result.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const printerAssignmentSlice = createSlice({
    name: 'printerAssignment',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // Get All
            .addCase(getPrinterAssignments.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPrinterAssignments.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.assignments = action.payload;
            })
            .addCase(getPrinterAssignments.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Assign Printer
            .addCase(assignPrinter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(assignPrinter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(assignPrinter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Update Status
            .addCase(updatePrinterStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePrinterStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updatePrinterStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Delete
            .addCase(deletePrinterAssignment.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePrinterAssignment.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deletePrinterAssignment.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            // Test Printer
            .addCase(testPrinter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(testPrinter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(testPrinter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = printerAssignmentSlice.actions;
export default printerAssignmentSlice.reducer;
